import { TEXT_STYLES } from '../../constants/styles';

/**
 * Reusable section heading component
 */
function SectionHeading({ children, className = '', level = 2 }) {
  const baseClasses = `${TEXT_STYLES.heading} mb-6 ${className}`;

  switch (level) {
    case 1:
      return <h1 className={baseClasses}>{children}</h1>;
    case 3:
      return <h3 className={baseClasses}>{children}</h3>;
    case 4:
      return <h4 className={baseClasses}>{children}</h4>;
    case 5:
      return <h5 className={baseClasses}>{children}</h5>;
    case 6:
      return <h6 className={baseClasses}>{children}</h6>;
    default:
      return <h2 className={baseClasses}>{children}</h2>;
  }
}

export default SectionHeading;
